module.exports = __webpack_public_path__ + "img/logo.7e1fef1f.png";